export default __webpack_public_path__ + "static/media/alcaldia.f179db9d.png";